import styled from "styled-components";

export const StyledVerificationSchemaWrapper = styled.div`
  .verification-schema-head {
    padding: 20px 0 30px;
    display: grid;
    grid-template-columns: max-content 175px 1fr;
    grid-gap: 20px;
    
    &__change-service {
      display: inline-grid;
      justify-content:  end;
    }
    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
      &__change-service {
        justify-content: start;
      }
    }
`;

export const StyledChangeServiceVerificationWrapper = styled.div`
  display: inline-grid;
  grid-template-rows: 55px;
  button {
    height: 100%;
  }
`;

export const StyledVerificationSchemaDetailsWrapper = styled.div`
  .fee-edit {
    display: grid;
    grid-template-columns: 150px 1fr;
    &__items {
      display: grid;
      grid-template-columns: 100%;
      grid-gap: 25px;
    }
    @media screen and (max-width: 576px) {
      grid-template-columns: 100px 1fr;
    }
  }
`;